import { EarningsInsight, EarningsInsightType } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EarningsInsightPill } from '../earnings-insight-pill/EarningsInsightPill';
import * as S from './EarningsInsightTypePill.styles';
import { constructMetadataSentence } from './utils';

export interface EarningsInsightTypePillProps {
  insightType: EarningsInsightType;
  createdAt: string;
  updatedAt?: string;
  showMetadataText?: boolean;
  isAnalyzing?: boolean;
  fy?: string;
  fq?: string;
  releasedDate?: string;
  entityTag: string;
  earningsInsight?: EarningsInsight;
}

export const EarningsInsightTypePill = ({
  insightType,
  createdAt,
  updatedAt,
  showMetadataText = true,
  isAnalyzing = false,
  fy,
  fq,
  releasedDate,
  entityTag,
  earningsInsight,
}: EarningsInsightTypePillProps) => {
  const { t } = useTranslation(['earnings']);

  const isPreview = insightType === 'preview';

  return (
    <S.Container>
      {earningsInsight && (
        <EarningsInsightPill
          entityTag={entityTag}
          earningsInsight={earningsInsight}
          isPreview={isPreview}
          isClickable={false}
        />
      )}
      {showMetadataText && createdAt && (
        <S.MetadataText>
          {constructMetadataSentence({
            createdAt,
            updatedAt,
            fy,
            fq,
            releasedDate,
            isPreview,
            t,
            isAnalyzing,
          })}
        </S.MetadataText>
      )}
    </S.Container>
  );
};
